import "./admin-magic-login.8f708d3e.js";
import "./admin-magic-login.60dba013.js";
import "./admin.002afb84.js";
import "./hub.ca2360e0.js";
import "./hub.e4c3e2f3.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c49"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c49"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bVyZz", function(module, exports) {

$parcel$export(module.exports, "getQueryParamsAsObject", function () { return $8af029480c819d98$export$a1c95a8abb4ece3a; });
$parcel$export(module.exports, "getQueryParamsAsString", function () { return $8af029480c819d98$export$75b58454a7a69b26; });
$parcel$export(module.exports, "removeURLParameters", function () { return $8af029480c819d98$export$f5b7264af7e31224; });
$parcel$export(module.exports, "escapeHtml", function () { return $8af029480c819d98$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "isValidSSORedirectUrl", function () { return $8af029480c819d98$export$3a1ec77606248520; });
function $8af029480c819d98$export$a1c95a8abb4ece3a() {
    const queryParams = new URLSearchParams(window.location.search);
    const paramsObj = {};
    // Iterate over all keys and values
    for (const [key, value] of queryParams)// Store them in an object
    paramsObj[key] = value;
    return paramsObj;
}
function $8af029480c819d98$export$75b58454a7a69b26() {
    return new URL(window.location.href).search; // This includes the leading '?'
}
function $8af029480c819d98$export$f5b7264af7e31224(params) {
    const urlParams = new URLSearchParams(window.location.search);
    params.forEach((param)=>{
        if (urlParams.has(param)) urlParams.delete(param);
    });
    if (urlParams.toString() === '') window.history.replaceState({}, '', `${location.pathname}`);
    else window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
}
function $8af029480c819d98$export$4cf11838cdc2a8a8(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}
function $8af029480c819d98$export$aed51752c5165419(url) {
    if (!url) return false;
    // Normalize and trim the URL
    const normalizedUrl = url.trim().toLowerCase();
    // Block dangerous protocols that can execute JavaScript
    const dangerousProtocols = [
        'javascript:',
        'data:',
        'vbscript:',
        'file:',
        'blob:',
        'about:'
    ];
    for (const protocol of dangerousProtocols)if (normalizedUrl.startsWith(protocol)) {
        console.warn(`[Security] Blocked dangerous redirect URL protocol: ${protocol}`);
        return false;
    }
    // Try to parse as URL to ensure it's well-formed
    try {
        // If it starts with / or ./ or ../ it's a relative URL - these are safe
        if (normalizedUrl.startsWith('/') || normalizedUrl.startsWith('./') || normalizedUrl.startsWith('../')) return true;
        // Try to parse as absolute URL
        const parsed = new URL(url);
        // Only allow http and https protocols for absolute URLs
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
            console.warn(`[Security] Blocked non-HTTP redirect URL protocol: ${parsed.protocol}`);
            return false;
        }
        return true;
    } catch (e) {
        // If it doesn't start with a protocol and isn't a relative path, it might be a malformed URL
        // Allow it if it looks like a relative path (doesn't contain :)
        if (!normalizedUrl.includes(':')) return true;
        console.warn('[Security] Blocked malformed redirect URL:', url);
        return false;
    }
}
function $8af029480c819d98$export$3a1ec77606248520(url) {
    if (!url) return false;
    const normalizedUrl = url.trim().toLowerCase();
    // Browsers silently strip \t, \n, \r from anywhere in a URL and leading/trailing C0 controls
    // before resolving it. Without this, 'java\tscript:alert(1)' slips past startsWith() below
    // but executes when assigned to window.location.href.
    // Legitimate redirect URIs never contain these characters, so stripping is lossless for valid input.
    // Note: percent-encoded variants like %09 or %0A are unaffected — they are printable ASCII, not control bytes.
    const strippedUrl = normalizedUrl.replace(/[\t\n\r]/g, '').replace(/^[\u0000-\u001F]+|[\u0000-\u001F]+$/g, '');
    // Block dangerous protocols unconditionally
    const dangerousProtocols = [
        'javascript:',
        'data:',
        'vbscript:',
        'file:',
        'blob:',
        'about:'
    ];
    for (const protocol of dangerousProtocols)if (strippedUrl.startsWith(protocol)) {
        console.warn(`[Security] Blocked dangerous SSO redirect protocol: ${protocol}`);
        return false;
    }
    // Relative paths are same-origin — safe only if not protocol-relative (// or /\)
    if (normalizedUrl.startsWith('./') || normalizedUrl.startsWith('../')) return true;
    if (normalizedUrl.startsWith('/') && !normalizedUrl.startsWith('//') && !normalizedUrl.startsWith('/\\')) return true;
    // Absolute URLs must be http/https and on an approved domain
    try {
        const parsed = new URL(url);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
            console.warn(`[Security] Blocked non-HTTP SSO redirect protocol: ${parsed.protocol}`);
            return false;
        }
        const hostname = parsed.hostname.toLowerCase();
        // Approved SSO/OAuth redirect domains.
        // Add new partner domains here explicitly — do not use wildcards.
        const allowedExact = [
            'learner.plus',
            'www.learner.plus',
            'staging.learner.plus',
            'beta.learner.plus',
            'cmefy.com',
            'www.cmefy.com',
            'localhost'
        ];
        // Allow any subdomain of cmefy.com (mirrors existing CORS config: *.cmefy.com)
        const isAllowed = allowedExact.includes(hostname) || hostname.endsWith('.cmefy.com');
        if (!isAllowed) {
            console.warn(`[Security] Blocked SSO redirect to unlisted domain: ${hostname}`);
            return false;
        }
        return true;
    } catch (e) {
        console.warn('[Security] Blocked malformed SSO redirect URL:', url);
        return false;
    }
}
function $8af029480c819d98$export$ef3a480f41ec5e16(url) {
    if (!url) return false;
    // Normalize and trim the URL
    const normalizedUrl = url.trim().toLowerCase();
    // Block dangerous protocols that can execute JavaScript
    const dangerousProtocols = [
        'javascript:',
        'data:',
        'vbscript:',
        'file:',
        'blob:',
        'about:'
    ];
    for (const protocol of dangerousProtocols)if (normalizedUrl.startsWith(protocol)) {
        console.warn(`[Security] Blocked dangerous transcript redirect URL protocol: ${protocol}`);
        return false;
    }
    // Try to parse as URL to ensure it's well-formed
    try {
        // If it starts with / or ./ or ../ it's a relative URL - these are safe (same domain)
        if (normalizedUrl.startsWith('/') || normalizedUrl.startsWith('./') || normalizedUrl.startsWith('../')) return true;
        // Try to parse as absolute URL
        const parsed = new URL(url);
        // Only allow http and https protocols for absolute URLs
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
            console.warn(`[Security] Blocked non-HTTP transcript redirect URL protocol: ${parsed.protocol}`);
            return false;
        }
        // Only allow same-domain redirects (learner.plus domains)
        const allowedDomains = [
            'learner.plus',
            'www.learner.plus'
        ];
        if (!allowedDomains.includes(parsed.hostname)) {
            console.warn(`[Security] Blocked external transcript redirect to domain: ${parsed.hostname}`);
            return false;
        }
        return true;
    } catch (e) {
        // If it doesn't start with a protocol and isn't a relative path, it might be a malformed URL
        // Allow it if it looks like a relative path (doesn't contain :)
        if (!normalizedUrl.includes(':')) return true;
        console.warn('[Security] Blocked malformed transcript redirect URL:', url);
        return false;
    }
}

});


var $cd71e = parcelRequire("cd71e");
var $hcepo = parcelRequire("hcepo");
var $cet0p = parcelRequire("cet0p");
var $am4Ss = parcelRequire("am4Ss");

var $ba1AG = parcelRequire("ba1AG");
parcelRequire("2shzp");

var $cEmXr = parcelRequire("cEmXr");
parcelRequire("cxzCy");
parcelRequire("9BO67");
parcelRequire("8Fos1");
parcelRequire("cV6qV");

var $bVyZz = parcelRequire("bVyZz");
$cet0p.init({
    dsn: "https://3fdb0c41327a83e4cb56d5b4b90581d0@o4506895983706112.ingest.us.sentry.io/4506895986524160",
    integrations: [
        $cd71e.browserTracingIntegration(),
        $am4Ss.internalReplayIntegration({
            maskAllText: false,
            blockAllMedia: false
        })
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        /^https:\/\/yourserver\.io\/api/
    ],
    // Session Replay
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0
});
(0, $ba1AG.default).init('cf94a02e44ddf7e05d5845558f9f89df', {
    debug: true,
    track_pageview: true,
    persistence: 'localStorage'
});
(function() {
    'use strict';
    // Code goes here...
    console.log("JSKJM!");
    var CURR_USER = false;
    var CURR_USERPROFILE = false;
    //
    const firebaseConfig = {
        apiKey: "AIzaSyAkOAXn8FEH1PKjf_aghihKEamNddBQB18",
        authDomain: "learner-plus.firebaseapp.com",
        projectId: "learner-plus",
        storageBucket: "learner-plus.appspot.com",
        messagingSenderId: "812434383550",
        appId: "1:812434383550:web:d2cda1285d3e3199a134ef"
    };
    // capture ALL the query params
    // /nudge-reflection?ipoc_keyword=Pain+Management&ipoc_context=Meeting&cmefy_id=jskjm_id&ipoc_secret=JSKJMSecret&reflectionkit=reflective-practice
    var CURR_QueryParams_Str = (0, $bVyZz.getQueryParamsAsString)(); // This includes the leading '?'
    var CURR_QueryParams_Obj = (0, $bVyZz.getQueryParamsAsObject)();
    // hide them for safety
    history.pushState(null, '', '/nudge-reflection?processing=jskjm');
    // Initialize Firebase
    const app = (0, $cEmXr.default).initializeApp(firebaseConfig);
    (0, $cEmXr.default).auth().onAuthStateChanged((user)=>{
        console.log(user);
        if (user) {
            // we have a user
            CURR_USER = user;
            $hcepo.setContext("CURR_USER", user);
            console.log(user.uid);
            UI_BindActions();
            //
            if (CURR_QueryParams_Obj.logout) {
                (0, $cEmXr.default).auth().signOut().then(()=>{
                    location.reload();
                }).catch((error)=>{
                    // An error happened.
                    showNotification('Logout Error', 'There was an error logging out - ' + error + '.', 'error', 3000);
                });
                return;
            }
            //
            // we see if the profile is filled out otherwise move forward
            (0, $cEmXr.default).firestore().collection('userprofiles').doc(user.uid).get().then((doc)=>{
                if (doc.exists) {
                    // we can take them to default/parameter reflectionkit
                    CURR_USERPROFILE = doc.data();
                    // activate free cert if param present and not already set
                    if (CURR_QueryParams_Obj.activate_free_cert === "true" && !CURR_USERPROFILE.certIncluded) (0, $cEmXr.default).firestore().collection('userprofiles').doc(user.uid).update({
                        certIncluded: true
                    });
                    document.getElementById('loading_overlay').classList.add('hidden');
                    navigateToReflectivePractice_Or_ProvidedKit();
                } else // we need to ask them to fill out the profile quickly, go take them to login
                navigateToLoginAndRegistration();
            }).catch((error)=>{
                $hcepo.captureException(error);
                showNotification('Profile Fetch Error', 'There was an error fetching your profile - ' + error + '.', 'error', 4500);
            });
        //
        } else {
            // no authenticated user, lets force the token or try to log them in
            if (CURR_QueryParams_Obj.token) try {
                (0, $cEmXr.default).auth().signInWithCustomToken(CURR_QueryParams_Obj.token).then((signInSuccess)=>{
                    navigateToLoginAndRegistration();
                }).catch((errInToken)=>{
                    navigateToLoginAndRegistration();
                });
            } catch (ex) {
                // we push them to login manually
                navigateToLoginAndRegistration();
            }
            else navigateToLoginAndRegistration();
        }
    });
    function UI_BindActions() {
        document.getElementById('learnerplus').addEventListener('click', function(event) {
            // Check if the clicked element has the class 'ui-action-btn'
            if (event.target.classList.contains('ui-action-btn')) {
                event.preventDefault();
                var uiTask = event.target.getAttribute('data-task');
                performTask(uiTask);
            }
        });
    }
    function performTask(uiTask) {
        switch(uiTask){
            case 'dismiss-modal':
                document.getElementById('npi').value = '';
                document.getElementById('npi-import-modal').classList.add([
                    'hidden'
                ]);
                break;
            case "appnotifier-dismiss":
                console.log("dismisser");
                document.getElementById('appnotifier').classList.remove('opacity-100', 'scale-100');
                document.getElementById('appnotifier').classList.add('opacity-0', 'scale-95', 'hidden');
                break;
            case "logout-curruser":
                if (confirm('Are you sure you want to logout?')) (0, $cEmXr.default).auth().signOut().then(()=>{
                    location.reload();
                }).catch((error)=>{
                    // An error happened.
                    showNotification('Logout Error', 'There was an error logging out - ' + error + '.', 'error', 3000);
                });
                break;
            default:
                break;
        }
    }
    /**
     * Determines the appropriate reflectionkit based on user credential
     * @param {string} credential - User's credential from profile
     * @returns {string} - The reflectionkit identifier
     */ function getReflectionkitFromCredential(credential) {
        // Handle missing or invalid credentials
        if (!credential || credential === 'not-selected') {
            console.warn('No valid credential found, defaulting to reflective-practice');
            return 'reflective-practice';
        }
        // Credentials that should use reflective-thinking
        const REFLECTIVE_THINKING_CREDENTIALS = [
            'Lifelong-Learner',
            'Student',
            'Fellow',
            'Resident'
        ];
        if (REFLECTIVE_THINKING_CREDENTIALS.includes(credential)) return 'reflective-thinking';
        // Default for all other credentials (healthcare professionals)
        return 'reflective-practice';
    }
    function navigateToLoginAndRegistration() {
        if (CURR_QueryParams_Obj.redirect_url && CURR_QueryParams_Obj.redirect_url.startsWith('/') && !CURR_QueryParams_Obj.redirect_url.startsWith('//') && !CURR_QueryParams_Obj.redirect_url.startsWith('/\\')) window.location.href = CURR_QueryParams_Obj.redirect_url;
        else if (CURR_QueryParams_Obj.redirect_url) {
            console.warn('[Security] Blocked invalid redirect_url, falling back to /');
            window.location.href = '/';
        } else // Let login page handle kit selection based on credential
        // Don't set a default here - login logic will determine based on credential
        window.location.href = `/login${CURR_QueryParams_Str}`;
    }
    function navigateToReflectivePractice_Or_ProvidedKit() {
        if (CURR_QueryParams_Obj.redirect_url && CURR_QueryParams_Obj.redirect_url.startsWith('/') && !CURR_QueryParams_Obj.redirect_url.startsWith('//') && !CURR_QueryParams_Obj.redirect_url.startsWith('/\\')) window.location.href = CURR_QueryParams_Obj.redirect_url;
        else if (CURR_QueryParams_Obj.redirect_url) {
            console.warn('[Security] Blocked invalid redirect_url, falling back to /');
            window.location.href = '/';
        } else {
            var targetReflectionKit = '';
            const credentialKit = CURR_USERPROFILE && CURR_USERPROFILE.credential ? getReflectionkitFromCredential(CURR_USERPROFILE.credential) : null;
            // PRIORITY 1: Credential override for student/resident/fellow/lifelong-learner
            // These always route to reflective-thinking regardless of stored kit — matches login flow
            if (credentialKit === 'reflective-thinking') {
                targetReflectionKit = 'reflective-thinking';
                console.log('Credential requires reflective-thinking, routing accordingly:', CURR_USERPROFILE.credential);
            } else if (CURR_USERPROFILE && CURR_USERPROFILE.reflectionkits && CURR_USERPROFILE.reflectionkits[0]) {
                targetReflectionKit = CURR_USERPROFILE.reflectionkits[0];
                console.log('Using stored reflectionkit from user profile:', targetReflectionKit);
            } else if (credentialKit) {
                targetReflectionKit = credentialKit;
                console.log('Auto-selecting reflectionkit based on credential:', targetReflectionKit);
            } else {
                targetReflectionKit = "reflective-practice";
                console.log('Using default reflectionkit:', targetReflectionKit);
            }
            // Sync reflectionkit param with actual routing decision
            // (credential may have overridden a stale URL param — replace it so path and param match)
            CURR_QueryParams_Str = CURR_QueryParams_Str.replace(/([?&])reflectionkit=[^&]*/g, `$1reflectionkit=${targetReflectionKit}`);
            if (!CURR_QueryParams_Str.includes('reflectionkit=')) CURR_QueryParams_Str += (CURR_QueryParams_Str.includes("?") ? "&" : "?") + `reflectionkit=${targetReflectionKit}`;
            window.location.href = '/' + targetReflectionKit + (CURR_QueryParams_Str ? CURR_QueryParams_Str : '');
        }
    }
    function showNotification(notificationTitle, notificationContent, notificationType, notiificationDuration) {
        document.getElementById('appnotifier-title').innerHTML = notificationTitle;
        document.getElementById('appnotifier-content').innerHTML = notificationContent;
        document.getElementById('appnotifier').classList.remove('opacity-0', 'scale-95', 'hidden');
        document.getElementById('appnotifier').classList.add('opacity-100', 'scale-100');
        setTimeout(function() {
            performTask('appnotifier-dismiss');
        }, notiificationDuration);
    }
})();


//# sourceMappingURL=nudge-reflection.721a6443.js.map
